import type React from 'react';
import { COMPANY_INFO } from '../utils/constants';

const SchemaMarkup: React.FC = () => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'IT Joy',
    url: 'https://itjoy.space',
    logo: 'https://itjoy.space/src/assets/images/logo.svg',
    description: 'IT Joy – ваш надежный IT-партнер с 2005 года. Мы строим и обслуживаем IT-инфраструктуру, которая работает на ваш бизнес.',
    foundingDate: '2005',
    address: {
      '@type': 'PostalAddress',
      postalCode: '680000',
      streetAddress: COMPANY_INFO.address,
      addressLocality: 'Хабаровск',
      addressRegion: 'Хабаровский край',
      addressCountry: 'RU'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: COMPANY_INFO.phone,
      contactType: 'customer service',
      email: COMPANY_INFO.email,
      availableLanguage: ['Russian']
    },
    sameAs: COMPANY_INFO.socialLinks.map(social => social.url)
  };

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'IT-услуги для бизнеса',
    provider: {
      '@type': 'Organization',
      name: 'IT Joy'
    },
    description: 'Полный цикл IT-услуг: проектирование, внедрение, сопровождение. Работаем честно, гибко и с гарантией результата для малого и среднего бизнеса.',
    areaServed: {
      '@type': 'City',
      name: 'Хабаровск'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'IT-услуги',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'IT-инфраструктура'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'IT-поддержка'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'IT-аутсорсинг'
          }
        }
      ]
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
    </>
  );
};

export default SchemaMarkup; 